export const AUDIENCE_VISITOR_KEY = 'mp_audience_visitor_v1';
export const AUDIENCE_CONSENT_EVENT = 'mp-consent-changed';
const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/marketplace/audience/event`;
const MAX_AGE = 90 * 24 * 60 * 60 * 1000;
const PUBLIC = new Set(['/', '/viaturas', '/motoristas', '/comprar-viaturas-tvde', '/vender-viatura',
  '/anunciar-viatura', '/publicar-procura', '/gerir-anuncio', '/precos', '/publicidade', '/parceiros',
  '/stands', '/associacoes-tvde', '/profissionais-tvde', '/adicionar-parceiro', '/noticias-tvde',
  '/noticias-tvde/legislacao', '/termos', '/privacidade', '/cookies', '/aviso-legal', '/livre-resolucao', '/seguranca']);

export const audienceAllowed = () => {
  try { return JSON.parse(localStorage.getItem('mp_cookie_consent_v2'))?.categories?.analytics === true; }
  catch (_) { return false; }
};

export const isAudiencePage = (path) => PUBLIC.has(path) ||
  /^\/(viaturas|motoristas|comprar-viaturas-tvde|parceiros)\/[a-zA-Z0-9-]{1,180}$/.test(path) ||
  /^\/noticias-tvde\/(artigo|categoria)\/[a-zA-Z0-9-]{1,180}$/.test(path);

export const audienceVisitor = () => {
  let existing;
  try { existing = JSON.parse(localStorage.getItem(AUDIENCE_VISITOR_KEY) || 'null'); } catch (_) { existing = null; }
  if (existing?.id && Date.now() - existing.created < MAX_AGE) return existing.id;
  const id = crypto.randomUUID();
  localStorage.setItem(AUDIENCE_VISITOR_KEY, JSON.stringify({ id, created: Date.now() }));
  return id;
};

export const existingAudienceVisitor = () => {
  try { return JSON.parse(localStorage.getItem(AUDIENCE_VISITOR_KEY))?.id || null; }
  catch (_) { return null; }
};

export const sendAudience = (payload) => fetch(ENDPOINT, {
  method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload), keepalive: true, signal: AbortSignal.timeout(10000),
}).then((r) => r.ok ? r.json() : { accepted: false }).catch(() => ({ accepted: false }));